// extracted by mini-css-extract-plugin
export var searchHeader = "_7g-0";
export var searchHeaderDark = "_7g-1";